import { lazy } from 'react';
import { DashboardLayout } from 'app/components';
import { routingPath } from 'app/routes';

const UsersAccessPage = lazy(() =>
  import('../pages/UsersAccessPage').then((m) => ({
    default: m.UsersAccessPage,
  })),
);
const UsersAccessHandler = lazy(() =>
  import('../pages/UsersAccessHandler').then((m) => ({
    default: m.UsersAccessHandler,
  })),
);
const UsersAccessDetails = lazy(() =>
  import('../pages/UsersAccessDetails').then((m) => ({
    default: m.UsersAccessDetails,
  })),
);

const ManagementRoutes = () => {
  return {
    element: <DashboardLayout />,
    children: [
      {
        path: routingPath.management.access,
        element: <UsersAccessPage />,
      },
      {
        path: routingPath.management.accessNew,
        element: <UsersAccessHandler />,
      },
      {
        path: routingPath.management.accessView,
        element: <UsersAccessDetails />,
      },
    ],
  };
};

export default ManagementRoutes;
